import { createContext } from './context';
import { createSession, getState, saveBeforeRedirect, saveState } from './session';
import { fetchTimeSlots, reserveTime } from './timeslots';
import { getChildren } from './children';
import { lookupBooking, cancelBooking } from './booking';
import { getSignUrl } from './signing';
import type { CreateSelfServiceApiOptions, SelfServiceApi } from './types';

export const createSelfServiceApi = (options: CreateSelfServiceApiOptions = {}): SelfServiceApi => {
  const ctx = createContext(options);

  return {
    createSession: () => createSession(ctx),
    saveState: (sessionId, state) => saveState(ctx, sessionId, state),
    saveBeforeRedirect: (sessionId, state, redirectType) => saveBeforeRedirect(ctx, sessionId, state, redirectType),
    getState: sessionId => getState(ctx, sessionId),
    fetchTimeSlots: days => fetchTimeSlots(ctx, days),
    reserveTime: (sessionId, date, time, location) => reserveTime(ctx, sessionId, date, time, location),
    getChildren: opts => getChildren(ctx, opts),
    lookupBooking: (bookingRef, phone, sessionId) => lookupBooking(ctx, bookingRef, phone, sessionId),
    cancelBooking: (sessionId, bookingRef) => cancelBooking(ctx, sessionId, bookingRef),
    getSignUrl: (sessionId, flowId) => getSignUrl(ctx, sessionId, flowId)
  };
};

export const selfServiceApi: SelfServiceApi = createSelfServiceApi();

export type { SelfServiceApi, CreateSelfServiceApiOptions } from './types';
export type { SelfServiceState } from '../../types';



